<template>
  <!-- 大图 -->
  <a class="infoflow-item big" target="_blank" :href="url" v-if="adStyle === 1">
    <div class="infoflow-title e-2" v-if="text">{{ text }}</div>

    <YorkbbsImage class="infoflow-cover__big" :src="appImages[0] | webpFormat(750)" v-if="appImages[0]"></YorkbbsImage>

    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 小图 -->
  <a class="infoflow-item small" target="_blank" :href="url" v-else-if="adStyle === 2">
    <div class="infoflow-others">
      <div class="infoflow-title e-2" v-if="text">{{ text }}</div>
      <div class="infoflow-extend">
        <span class="infoflow-adv">广告</span>
      </div>
    </div>

    <YorkbbsImage
      class="infoflow-cover__small"
      :src="appImages[0] | webpFormat(200)"
      v-if="appImages[0]"
    ></YorkbbsImage>
  </a>
  <!-- 三图 -->
  <a class="infoflow-item multi" target="_blank" :href="url" v-else-if="adStyle === 3">
    <div class="infoflow-title e-2" v-if="text">{{ text }}</div>
    <div class="infoflow-images">
      <div class="infoflow-item-img" v-for="(item, i) in appImages"
          :key="i">
        <YorkbbsImage
          class="infoflow-image"
          aspect
          :src="item | webpFormat(250)"
        ></YorkbbsImage>
      </div>
    </div>
    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 纯文字 -->
  <a class="infoflow-item text" target="_blank" :href="url" v-else-if="adStyle === 4">
    <div class="infoflow-title e-2" :style="{ fontWeight: fontWeight ? 600 : 400, color: fontColor }" v-if="text">
      {{ text }}
    </div>
    <div class="infoflow-extend">
      <span class="infoflow-adv">广告</span>
    </div>
  </a>
  <!-- 代码广告 -->
  <iframe
    :data-space="material.speaceId" :data-material="material.id"
    :id="onlyTag"
    class="kjwt-item infoflow-item"
    frameborder="0"
    scrolling="no"
    :src="codeURL"
    v-else-if="adStyle === 5"
    :style="{ width: `100%`, height: `80px` }"
  ></iframe>
</template>
<script>
export default {
  name: 'ItemInfoflow',
  props: { data: Object },
  computed: {
    material() {
      return this.data.material || {};
    },
    // 信息流广告样式 1:大图 2:小图 3:3图 4:文字
    adStyle() {
      return this.material.pcAdStyle||this.material.adStyle;
    },
    appImages() {
      return this.material.appImages || [];
    },
    url() {
      return this.material.url;
    },
    // 标题，可选
    text() {
      return this.material.text;
    },
    // 标题颜色
    fontColor() {
      return this.material.fontColor;
    },
    // 标题是否加粗
    fontWeight() {
      return this.material.fontWeight;
    },
    textFiled1() {
      return this.material.textFiled1;
    },
    textFiled2() {
      return this.material.textFiled2;
    },
    textFiled3() {
      return this.material.textFiled3;
    },
    textFiled4() {
      return this.material.textFiled4;
    },
    // 代码广告地址
    codeURL() {
      return `/crm/inventory/code/${this.material.id}`;
    },
  },
};
</script>
<style lang="less" scoped>
.infoflow-item {
  display: block;
  padding: 15px 0;
  
  &.small {
    display: flex;
    justify-content: space-between;
  }
}
.infoflow-title {
  font-size: 16px;
  line-height: 24px;
  &:hover {
    color: var(--primary-color);
  }
}
.infoflow-cover__big {
  margin-top: 6px;
  border-radius: 4px;
}
.infoflow-extend {
  margin-top: 6px;
}
.infoflow-adv {
  font-size: 12px;
  line-height: 16px;
  color: var(--text-color-9);
}
.infoflow-others {
  flex: 1;
  width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infoflow-cover__small {
  width: 100px;
  height: 75px;
  margin-left: 15px;
  border-radius: 4px;
}
.infoflow-images {
  display: flex;
  margin: 0 -5px;
  margin-top: 6px;
}
.infoflow-item-img{
  width: 33.33%; padding: 0 5px;
}
</style>
